/**
 * Sets up the routing for all Admin views.
 *
 * NOTE: All imported [Module]AdminRouter files must be wrapped in a Route wrapper
 * inside the switch in order to resolve correctly.  See <UserAdminRouter/>
 * below as an example.
 */

// import primary libraries
import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';
// import ZendeskWidgetSettings from '../../global/plugins/zendesk/ZendeskWidgetSettings.js.jsx';

// import admin views
import AdminDashboard from './views/AdminDashboard.js.jsx';
import AuthoringDashboard from './views/AuthoringDashboard.js.jsx';

// import admin components
import AdminLayout from './components/AdminLayout.js.jsx';

// import authoring routes
import CourseAdminRouter from '../course/CourseAdminRouter.js.jsx';
import EvaluationAdminRouter from '../evaluation/EvaluationAdminRouter.js.jsx';
import ResourceLinkAdminRouter from '../resourceLink/ResourceLinkAdminRouter.js.jsx';
import SceneAdminRouter from '../scene/SceneAdminRouter.js.jsx';
import MetricAdminRouter from '../metric/MetricAdminRouter.js.jsx';
import MetricCategoryAdminRouter from '../metricCategory/MetricCategoryAdminRouter.js.jsx';
import StudyAdminRouter from '../study/StudyAdminRouter.js.jsx';
import ContentModuleAdminRouter from '../contentModule/ContentModuleAdminRouter.js.jsx';

// import other admin routes
import SiteAdminRouter from '../site/SiteAdminRouter.js.jsx';
import SiteLocationAdminRouter from '../siteLocation/SiteLocationAdminRouter.js.jsx';
import SponsorAdminRouter from '../sponsor/SponsorAdminRouter.js.jsx';
import UserAdminRouter from '../user/UserAdminRouter.js.jsx';
import CertificateTemplateAdminRouter from '../certificateTemplate/CertificateTemplateAdminRouter.js.jsx';
import AuditLogRouter from '../auditLog/AuditLogRouter.js.jsx';
import SentimentQuestionRouter from '../sentimentQuestion/SentimentQuestionRouter.js.jsx';
import SentimentAnswerRouter from '../sentimentAnswer/SentimentAnswerRouter.js.jsx';

class AdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <AdminLayout>
        <Switch>
          <YTRoute role="admin" exact path="/admin" component={AdminDashboard} />
          <YTRoute role="admin" path="/admin/users">
            <UserAdminRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/sponsors">
            <SponsorAdminRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/sites">
            <SiteAdminRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/site-locations">
            <SiteLocationAdminRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/certificate-templates">
            <CertificateTemplateAdminRouter/>
          </YTRoute>
          <YTRoute role="admin" path="/admin/audit-logs">
            <AuditLogRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/sentiment-questions">
            <SentimentQuestionRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/sentiment-answers">
            <SentimentAnswerRouter />
          </YTRoute>

          {/** CONTENT MANAGEMENT ROUTES */}
          <YTRoute role="admin" exact path="/admin/content-management" render={() => <Redirect to="/admin/content-management/studies"/>} />

          <YTRoute role="admin" path="/admin/content-management/studies">
            <StudyAdminRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/content-management/courses">
            <CourseAdminRouter />
          </YTRoute>

          {/** AUTHORING ROUTES */}
          <YTRoute role="admin" exact path="/admin/authoring" render={() => <Redirect to="/admin/authoring/evaluations"/>} />
          {/* <YTRoute role="admin" path="/admin/authoring/studies">
            <StudyAdminRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/authoring/courses">
            <CourseAdminRouter />
          </YTRoute> */}
          <YTRoute role="admin" path="/admin/authoring/content-modules">
            <ContentModuleAdminRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/authoring/evaluations">
            <EvaluationAdminRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/authoring/scenes">
            <SceneAdminRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/authoring/metrics">
            <MetricAdminRouter />
          </YTRoute>
          <YTRoute role="admin" path="/admin/authoring/metric-categories">
            <MetricCategoryAdminRouter />
          </YTRoute>
        </Switch>
      </AdminLayout>
    )
  }
}

export default AdminRouter;



// WEBPACK FOOTER //
// modules/admin/AdminRouter.js.jsx